export default {
  namespaced: true,
  state: {
    checkList: [],
    smartCheckList: [],
    currentTicker: null,
    checkListMap: {},
    smartCheckListMap: {},
  },
  mutations: {
    setTicker(state, ticker) {
      const list = generateCheckList(ticker); // 체크리스트 생성
      state.currentTicker = ticker; // 어떤 ticker인지 저장
      state.checkList = list; // 해당 ticker의 체크리스트 화면에 띄움
      state.checkListMap[ticker] = list; // 위에서 보여준 체크리스트를 map에 보관
    },

    setSmartTicker(state, ticker) {
      console.log("Setting smart ticker:", ticker); // 추가
      const list = generateSmartCheckList(ticker); // 체크리스트 생성
      state.currentTicker = ticker; // 어떤 ticker인지 저장
      state.smartCheckList = list; // 해당 ticker의 체크리스트 화면에 띄움
      state.smartCheckListMap[ticker] = list; // 위에서 보여준 체크리스트를 map에 보관
    },

    toggleCheck(state, { id, value }) {
      const item = state.checkList.find((item) => item.id === id);
      if (item) {
        item.checked = value;
      }
    },
  },
  actions: {
    setTicker({ commit }, ticker) {
      commit("setTicker", ticker);
    },

    setSmartTicker({ commit }, ticker) {
      commit("setSmartTicker", ticker);
    },

    toggleCheck({ commit }, payload) {
      commit("toggleCheck", payload);
    },
  },
  getters: {
    isChecked: (state) => (ticker, id) => {
      const list = state.checkListMap[ticker];
      if (!list) return false;
      const item = list.find((item) => item.id === id);
      return item ? item.checked : false;
    },

    isSmartChecked: (state) => (ticker, id) => {
      const list = state.smartCheckListMap[ticker];
      if (!list) return false;
      const item = list.find((item) => item.id === id);
      return item ? item.checked : false;
    },

    // getCheckList: (state) => state.checkList,
    getCheckList: (state) => (ticker) => {
      return state.checkListMap[ticker] || [];
    },

    getSmartCheckList: (state) => (ticker) => {
      return state.smartCheckListMap[ticker] || [];
    },
  },
};

function generateCheckList(ticker) {
  return [
    {
      key: `${ticker}_all`,
      id: "all",
      value: "chart1.all",
      checked: false,
      name: `${ticker}_chkOption`,
      selectAll: true,
      highlight: false,
      disable: false,
    },
    {
      key: `${ticker}_pink`,
      id: "pink",
      value: "chart1.kibotLine",
      checked: true,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_trend`,
      id: "trend",
      value: "chart1.trend",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_sr`,
      id: "sr",
      value: "chart1.sr",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_hei`,
      id: "hei",
      value: "chart1.heikin",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_ma3`,
      id: "ma3",
      value: "chart1.3ma",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_bb`,
      id: "bb",
      value: "chart1.bb",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_rsi`,
      id: "rsi",
      value: "chart2.RSI",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_macd`,
      id: "macd",
      value: "MACD",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_rls`,
      id: "rls",
      value: "RLS",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
  ];
}

function generateSmartCheckList(ticker) {
  return [
    {
      key: `${ticker}_all`,
      id: "all",
      value: "chart1.all",
      checked: false,
      name: `${ticker}_chkOption`,
      selectAll: true,
      highlight: false,
      disable: false,
    },
    {
      key: `${ticker}_pink`,
      id: "pink",
      value: "chart1.kibotLine",
      checked: true,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_trend`,
      id: "trend",
      value: "chart1.trend",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
    {
      key: `${ticker}_sr`,
      id: "sr",
      value: "chart1.sr",
      checked: false,
      name: `${ticker}_chkOption`,
      disable: false,
    },
  ];
}
